export class SocketMessageModel {
  static TYPE_UPDATE_CHAT: string = 'UPDATE_CHAT_MESSAGE';

  userId: string;
  messageType: string;
  message: object;
}
